export default {
  props: {
    // 组件名称
    componentName: {
      default: 'RichTextColumn',
      type: String,
    },
    // 组件类型
    componentType: {
      default: 0,
      type: Number,
    },
    // 组件标题
    componentTitle: {
      default: '',
      type: String,
    },
    // 自定义组件内容
    title: {
      default: '',
      type: String,
    },
    totalGrids: {
      default: 10,
      type: Number,
    },
    dataList: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {
      localDataList: JSON.parse(JSON.stringify(this.dataList)), // 深拷贝，避免引用同一个对象
    };
  },
  mounted() {
    this.updateEvaluationLinks();
  },
  methods: {
    updateEvaluationLinks() {
      const sourceId = this.$route?.query?.source_id || window.sessionStorage.getItem('source_id') || ''
      console.log('sourceId:', sourceId);
      if (!sourceId) return;

      this.localDataList = this.localDataList.map((item) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(item.content, 'text/html');
        const links = doc.querySelectorAll('a');

        let changed = false;

        links.forEach((link) => {
          const href = link.getAttribute('href');

          // 处理包含 "/evaluation" 且不包含参数的链接 和 老带新 /new-refer
          if (
            href
            && href.includes('/evaluation')
            && !href.includes('?')
            && !href.includes('#')
          ) {
            const newHref = `${href}?source_id=${sourceId}`;
            link.setAttribute('href', newHref);
            changed = true;
          } else if (
            href.includes('/new-refer')
            && !href.includes('source_id')
          ) {
            const hasQuery = href.includes('?');
            const newHref = `${href + (hasQuery ? '&' : '?')}source_id=${sourceId}`;
            link.setAttribute('href', newHref);
            changed = true;
          }
        });

        return {
          ...item,
          content: changed ? doc.body.innerHTML : item.content,
        };
      });
    },
  },
}
